export const primaryButtonStyles = {
  S: `
    padding: 0.7rem 1.6rem; 
    max-width: 12rem; 
    border-radius: 0.6rem;
    font-size: 1.6rem; 
    font-weight: 400; 
    line-height: 2.6rem;
  `,
  M: `
    padding: 1.4rem 2.4rem; 
    max-width: 28rem; 
    border-radius: 1.2rem;
    font-size: 1.8rem; 
    font-weight: 700; 
    line-height: 2.8rem;
  `,
  L: `
    padding: 1.4rem 2.4rem; 
    max-width: 72rem; 
    border-radius: 1.2rem;
    font-size: 1.8rem; 
    font-weight: 700; 
    line-height: 2.8rem;
  `,
};
